* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.hidden {
  display: none;
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 2.5);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

.dropdown-from-field {
  padding-top: 16px;
  --margin-bottom-wrapper: var(--spacer);
}

.selection-group-form-field {
  width: 35%;
  --margin-bottom-wrapper: var(--spacer);
}

.description-form-field {
  width: 100%;
  --margin-bottom-wrapper: var(--spacer);
}
